import { Injectable } from "@angular/core";
import { BehaviorSubject, Subject } from "rxjs";
import { IConfigurationDto, IPageDto } from "../models/auto-generated";

@Injectable()
export abstract class AConfigurationsFacade {
  protected error = new BehaviorSubject<string>(undefined);
  readonly error$ = this.error.asObservable();

  protected result = new BehaviorSubject<IPageDto<IConfigurationDto>>(undefined);
  readonly result$ = this.result.asObservable();

  constructor() {}

  private disposed = new Subject<boolean>();
  readonly dispose$ = this.disposed.asObservable();

  dispose(): Promise<void> {
    /** The promise is used here to enable self-hosted configurations-facade do a task asynchronously */
    return new Promise((resolve) => {
      this.result.next(undefined);
      this.disposed.next(true);
      resolve();
    });
  }

  abstract load(pageIndex: number, pageSize: number, filterText?: string): void;
}
